import React from 'react'
import {GeoJSON, TileLayer} from 'react-leaflet';
import GISTools from '#/lib/GISTools';
import "#/backoffice/style/PolygonMapComponent.css"
import MapComponent from "#/commons/map/MapComponent";


import _ from 'lodash';
import InputSelectComponent from "#/commons/components/InputSelectComponent";
import MapWatermark from "#/commons/map/MapWatermark";

export default class StationGisPicker extends React.Component {

	/*
	showAvailableMeasurements
	centerMapOnSelect
	geoJSON

	zoneOptions
	selectedZone
	onSelectZone

	stationOptions
	selectedStation
	onSelectStation

	availableMesaurements
	selectedMeasure
	onSelectMeasure

	onEachStation
	stationToMarker
	zonesStyle

	mapKey

	*/
	constructor(props) {
		super(props);
		this.state = {
			zoneBbox : null
		};
	}
	mapOptions = {
		center: [39.11, 16.55],
		zoom: 8,
		minZoom: 6,
		maxZoom: 11,
		width: "40vw",
		height: "60vh"
	}

	componentDidMount(){
		const {zoneBbox} = this.props;
		if (!!zoneBbox){
			this.setState({zoneBbox})
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const {zoneBbox} = this.props;
		const {zoneBbox : prevBbox} = prevProps;

		if (!!zoneBbox && !_.isEqual(zoneBbox, prevBbox)){
			this.setState({zoneBbox})
		}
	}


	onSelectZone(zoneId){

		let stations = this.props.geoJSON;
		let zoneBbox = GISTools.getBBoxFromPoints(GISTools.getCalabriaBorders());
		if (!!zoneId & zoneId !== 9999) {
			let zonePolygon = GISTools.getZonePolygonByField("ZONE", zoneId);

			zoneBbox = GISTools.getBBoxFromPoints(zonePolygon);
			let stationWithinZone = GISTools.intersect(stations, zonePolygon);
			stations = stationWithinZone;
		}
		this.setState({zoneBbox},() => {
			this.props.onSelectZone(zoneId);
		})
	}


	onSelectStation(stationCode){
		if (stationCode === null){
			this.onSelectZone(null)
		} else {

		let stationPoint = GISTools.getStationByField(this.props.geoJSON, "code", stationCode);
		if (!!stationPoint){
			let zoneBbox = GISTools.getBBoxFromPoints(stationPoint);
			this.setState({zoneBbox}, () => {
				this.props.onSelectStation(stationCode);
			})
		}
		}
	}

	onSelectMeasure(measurementCode){
		if (measurementCode === null){
			this.onSelectZone(null)
		} else {
			this.props.onSelectMeasure(measurementCode);
		}
	}
	render() {

		const titleMap = "Leaflet - A JavaScript library for interactive maps";
		let singleSelection = window.location.href.includes("backoffice") && window.location.href.includes("data");
		const tile = <TileLayer
			attribution={`<a href="https://leafletjs.com" title="${titleMap}" target="_blank"><i class="fas fa-info-circle fa-1x mr-1"  style="color: #0078A8"></i></a>
			<a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a> `}
			url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
		/>;
		return (

			<div className="mt-4">
				<div className="mb-4 mt-2">
					<InputSelectComponent
						placeholder={(!this.props.selectedMeasure || singleSelection) ? "Selezione Stazione" : "Tutte le stazioni"}
						isSearchable={true}
						optionList={this.props.stationOptions}
						value={!!this.props.selectedStation ? this.props.selectedStation.value : null }
						onChange={(option) => this.onSelectStation(option)}
					/>
				</div>
				<div className="mb-4">
					<InputSelectComponent
						placeholder={(!this.props.selectedMeasure || singleSelection) ? "Selezione Zona" : "Tutte le zone"}
						optionList={this.props.zoneOptions}
						value={!!this.props.selectedZone ? this.props.selectedZone.value : null }
						onChange={(option) => this.onSelectZone(option)}
					/>
				</div>
				{!!this.props.showAvailableMeasurements
					?
					<div className="">
						<InputSelectComponent
							placeholder={"Selezione Misura"}
							isSearchable={true}
							deleteTooltip={"Rimuovi misura selezionata"}
							optionList={this.props.availableMesaurements}
							value={!!this.props.selectedMeasure ? this.props.selectedMeasure.value : null }
							onChange={selectedOption=> this.onSelectMeasure(selectedOption)}
						/>
					</div>
					:
					<></>
				}


				<div className="custom-popup ">

					<MapComponent
						width={"100%"}
						height={this.props.mapHeight ?? this.mapOptions.height}
						zoom={this.mapOptions.zoom}
						zoomSnap={false}
						minZoom={this.mapOptions.minZoom}
						maxZoom={this.mapOptions.maxZoom}
						tile={tile}
						zoneBbox={this.state.zoneBbox}>

						<GeoJSON key={"stations_" + this.props.mapKey}
								 data={this.props.geoJSON}
								 onEachFeature={(feature, layer) => this.props.onEachStation(feature, layer)}
								 pointToLayer={(feature, latlng) => this.props.stationToMarker(feature, latlng)}
						/>

						<GeoJSON key={"borders_" + this.props.mapKey}
								 data={GISTools.getCalabriaBorders()}
								 style={{
									 fillColor: "#fff",
									 fillOpacity: 0,
									 weight: 2,
									 opacity: 1,
									 color: "green",
								 }}
						/>

						<GeoJSON key={"zone_" + this.props.mapKey}
								 data={GISTools.getAllZonePolygon()}
								 style={(feature) => this.props.zonesStyle(feature)}
						/>
						{this.props.suggestedStations && <MapWatermark
							key={'watermark_'}
							customClass={'watermark'}
							text={'<img src="/img/marker_point_selected.png" style="height:2rem" /> &nbsp;Stazioni suggerite'}/>}

					</MapComponent>
				</div>
			</div>


		)
	}
}


